import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { IRequestAggregatorItemRequest } from '@nimbus-global/features/shared/models/api/request-aggregator/i-request-aggregator-item.request';
import { IRequestAggregatorItemResponse } from '@nimbus-global/features/shared/models/api/request-aggregator/i-request-aggregator-item.response';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';

@Injectable({ providedIn: 'root' })
export class RequestAggregatorApiClient {
  public constructor(private readonly httpService: BaseHttpService) {}

  public request(requests: IRequestAggregatorItemRequest[]): Observable<IRequestAggregatorItemResponse[]> {
    return this.httpService.post('request-aggregator/v1', requests);
  }
}
